import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Pagination, Loader} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import _ from 'lodash';
export class ManagePanelReviewers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewers: [],
      pageNum: 0,
      error: false,
      loading: false,
      numReviewers: 0,
      totalPages: 0,
    };
  }

  getReviewers = () => {
    const {token, sessionId} = this.props;
    this.setState({
      loading: true,
    });
    return REST.panelReviewV2
      .getReviewersBySession(token, sessionId, this.state.pageNum)
      .then(REST.handler.handleResponse)
      .then((reviewersRes) => {
        if (_.size(_.get(reviewersRes, 'content')) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          const reviewers = _.get(reviewersRes, 'content');
          let mappedReviewers;
          const uniqueUserIds = _.uniq(
            _.map(reviewers, (reviewer) => _.get(reviewer, 'reviewerPK.userId'))
          );
          let userIdPayload = {
            userId: uniqueUserIds,
          };
          REST.user
            .getProfilesForUsers(token, userIdPayload)
            .then(REST.handler.handleResponse)
            .then((usersData) => {
              if (!_.isNull(usersData)) {
                mappedReviewers = _.map(reviewers, (reviewer) => {
                  const matchUser = _.find(usersData, {
                    userId: _.get(reviewer, 'reviewerPK.userId'),
                  });
                  const firstName = _.get(matchUser, 'firstName')
                    ? _.get(matchUser, 'firstName')
                    : '';
                  const lastName = _.get(matchUser, 'lastName')
                    ? _.get(matchUser, 'lastName')
                    : '';
                  return {
                    ...reviewer,
                    mappedFullName: `${firstName} ${lastName}`,
                  };
                });
                this.setState({
                  reviewers: _.sortBy(mappedReviewers, ['mappedFullName']),
                  error: false,
                  loading: false,
                  numReviewers: _.get(reviewersRes, 'totalElements'),
                  totalPages: _.get(reviewersRes, 'totalPages'),
                });
              }
            });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  handlePageChange = async (e, {activePage}) => {
    await this.setState({pageNum: activePage - 1});
    this.getReviewers();
  };

  componentDidMount() {
    this.getReviewers();
  }

  renderTable(reviewers) {
    if (reviewers && reviewers.length) {
      return reviewers.map((reviewer) => {
        return (
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>
            {_.get(reviewer, 'mappedFullName')}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
            <Link
                to={`/panelReview/admin/sessions/${reviewer.reviewerPK.sessionId}/reviewers/${reviewer.reviewerPK.userId}`}
              >
                {_.get(reviewer, 'reviewerPK.userId')}
              </Link>
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {reviewer.suspended ? 'Inactive' : 'Active'}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {_.map(reviewer.groups, (o) => o.name).join(', ') || 'N/A'}
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell> </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  }

  render() {
    const {loading, error} = this.state;
    if (loading)
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    return (
      <React.Fragment>
        {error ? (
          <p>No reviewers assigned at this time.</p>
        ) : (
          <React.Fragment>
            <FemaGoTable summary="Manage reviewers table">
              <FemaGoTable.Header>
                <FemaGoTable.Row>
                  <FemaGoTable.HeaderCell>Name</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                  <FemaGoTable.HeaderCell>Group name</FemaGoTable.HeaderCell>
                </FemaGoTable.Row>
              </FemaGoTable.Header>
              <FemaGoTable.Body>
                {this.renderTable(this.state.reviewers)}
              </FemaGoTable.Body>
            </FemaGoTable>
            <Pagination
              activePage={this.state.pageNum + 1}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              boundaryRange={1}
              ellipsisItem={null}
              totalPages={this.state.totalPages}
              onPageChange={this.handlePageChange}
            ></Pagination>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ManagePanelReviewers);
